export const isZeroCurrency = (
  currency: string | null | undefined
): boolean => {
  if (!currency || currency === '$0.00') return true;
  const numericValue = parseFloat(currency.replace(/[^0-9.\-]/g, ''));
  return !isNaN(numericValue) && numericValue === 0;
};
